"use client";
import { createContext } from "react";

export const usercontext = createContext({});
export const locationcontext = createContext({});
